import type { Editor } from '@tiptap/react';
import { FiAlignLeft } from 'react-icons/fi';
import { buttonStyles } from '@/shared/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/shared/ui/dropdown-menu';
import { toolbarIconClass } from './toolbar-controls';

/**
 * The heading control: H2, H3, or back to a paragraph.
 *
 * Only H2 and H3 are registered in the schema — an H1 belongs to the page, not
 * to a field inside it, so offering it here would let an embedded description
 * compete with the document's own structure.
 */
export function HeadingMenu({ editor, isDisabled }: { editor: Editor; isDisabled: boolean }) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        aria-label="Text style"
        disabled={isDisabled}
        className={buttonStyles({ variant: 'ghost', size: 'xs' })}
      >
        <FiAlignLeft className={toolbarIconClass} aria-hidden="true" />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start">
        <DropdownMenuItem onClick={() => editor.chain().focus().toggleHeading({ level: 2 }).run()}>
          Heading 2
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => editor.chain().focus().toggleHeading({ level: 3 }).run()}>
          Heading 3
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => editor.chain().focus().setParagraph().run()}>
          Paragraph
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
